import type { FunctionComponent } from "react";

const MainContent: FunctionComponent = ({ children }) => (
  <div className="px-10 pt-7 pb-10 max-w-full">{children}</div>
);

export default MainContent;
